import truncate from 'lodash.truncate';

export const truncateStringLength: number = 110;

export const maskAllChars = (maskChar: string, value: string): string =>
  value
    .split('')
    .map(() => maskChar)
    .join('');

export const truncateString = (value: string, length: number = truncateStringLength): string =>
  truncate(value, { length });

export const removeWhiteSpaces = (value: string) => value.replace(/\s+/g, '');

export const capitalizeString = (value: string) => value.charAt(0).toUpperCase() + value.slice(1);
